export const COOKIES_NAME = {
    IS_LOG_IN: 'is_logged_in',
    TOKEN: 'token',
};

export const FORGOT_PASSWORD = 'forgot_password';
export const SET_PASSWORD = 'set_password';
export const VERIFY_OTP = 'verify_otp';

export const DATEFORMAT = 'M/dd/y';
export const DATEFORMAT_YMD = 'YYYY/MM/DD';
export const DATEFORMAT_MDY = 'MM-DD-YYYY';

// Episodes
export const NEXT_EPISODE = 'next';
export const PREVIOUS_EPISODE = 'previous';

export const FROM_PODPULSE = 'from_podPulse';
export const FROM_POST = 'from_post';

export const IS_PLAYING = 'isPlaying';
export const IS_PLAYING_FEED = 'isPlayingFeed';
export const STOP_MAIN_PLAYER = 'mainPlayerStop';
export const STOP_SUB_PLAYER = 'subPlayerStop';

export const APP_STORE_ANDROID = 'https://play.google.com/store/apps/details?id=com.pulsedin.app';
export const APP_STORE_IOS = 'https://apps.apple.com/us/app/id1509163787';
